import { useRoute, useRouteParams } from '#imports'

import type { CMSPageType } from '@backmarket/http-api/src/api-specs-content'

import {
  CMS_PAGE_TYPE_BY_ROUTE_NAME,
  PAGE_NAME_BY_PLP_SLUG,
  PAGE_NAME_BY_ROUTE_NAME,
} from '../service/content-service.config'

type PageParams = {
  pageType: CMSPageType
  pageName: string
  pageCategory?: string
}

export function usePageParamsFromRoute(): PageParams {
  const { name } = useRoute()
  const routeName = String(name)

  const { pageName: paramsPageName, pageCategory, slugV2 } = useRouteParams()

  const pageType = CMS_PAGE_TYPE_BY_ROUTE_NAME[routeName]

  const pageName =
    paramsPageName ||
    PAGE_NAME_BY_ROUTE_NAME[routeName] ||
    PAGE_NAME_BY_PLP_SLUG[slugV2]

  return {
    pageType,
    pageName,
    pageCategory,
  }
}
